/**
 * Добавляет вспомогательный класс `utilityfocus` для элемента body.
 */
export var forceUtilityFocus = function () {
    window.document.body.classList.add('utilityfocus');
};
